$(function() {
  const $idLikeTo = $('#idLikeTo'),
  $idLikeToBtn = $idLikeTo.find('#idLikeToBtn');

  $idLikeToBtn.on('click', function() {
    let isExpanded = $(this).attr('aria-expanded') === 'true' ? true : false;

    $(this).attr('aria-expanded', isExpanded ? 'false' : 'true');

    isExpanded ? remove_trap_focus($idLikeTo, 'idLikeToTrap') : trap_focus($idLikeTo, 'idLikeToTrap');
  });
});
